import { useEffect, useState } from "react";
import { navAnchors, siteMeta } from "@/mocks/news";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [menuOpen]);

  const light = !scrolled && !menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        light
          ? "bg-transparent"
          : "border-b border-background-200/70 bg-background-50/95 backdrop-blur"
      }`}
    >
      <div className="flex h-16 w-full items-center justify-between px-4 md:h-[72px] md:px-8">
        <a
          href="#top"
          className="flex items-center gap-2.5 whitespace-nowrap"
          aria-label={`${siteMeta.name} 首页`}
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-plant-line text-lg" aria-hidden />
          </span>
          <span className="flex flex-col leading-none">
            <span
              className={`font-heading text-lg font-black tracking-tight ${
                light ? "text-background-50" : "text-foreground-950"
              }`}
            >
              {siteMeta.name}
            </span>
            <span
              className={`mt-0.5 text-[11px] ${
                light ? "text-background-50/70" : "text-foreground-500"
              }`}
            >
              {siteMeta.slogan}
            </span>
          </span>
        </a>

        <nav aria-label="主导航" className="hidden items-center gap-0.5 lg:flex">
          {navAnchors.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className={`whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                light
                  ? "text-background-50/85 hover:bg-background-50/10 hover:text-background-50"
                  : "text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
              }`}
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            订阅首发
          </a>
          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
            aria-expanded={menuOpen}
            className={`flex h-9 w-9 items-center justify-center rounded-md transition-colors lg:hidden ${
              light
                ? "text-background-50 hover:bg-background-50/10"
                : "text-foreground-950 hover:bg-background-200"
            }`}
          >
            <i className={menuOpen ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 lg:hidden">
          <nav aria-label="移动端导航" className="flex flex-col p-4">
            {navAnchors.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setMenuOpen(false)}
                className="rounded-md px-3 py-3 text-sm text-foreground-800 transition-colors hover:bg-primary-50 hover:text-primary-600"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="mt-2 rounded-md bg-primary-500 px-3 py-3 text-center text-sm font-medium text-background-50"
            >
              订阅首发推送
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}